import React from 'react';

const CustomShapePreview = ({
  dpoData, dispatchRef = () => {
  },
}) => {
  if (!dpoData.preview_urls?.medium) {
    return null;
  }

  const { panel_width, panel_height, preview_urls: { medium } } = dpoData;
  return (
    <div className="mb-2xl">
      <div className="flex justify-between">
        <label
          className="block font-semibold mb-2xs text-sm desktop:text-base"
        >
          {Drupal.t('Your Artwork')}
        </label>
        <div
          className="flex items-center"
        >
          <div
            className="w-6xl border-t border-dashed border-t-4 border-[#000000] mr-3xs"></div>
          <div
            className="text-sm whitespace-nowrap">{Drupal.t('Trim line')}</div>
        </div>
      </div>
      <div
        className="flex justify-center items-center p-3xs bg-neutral-light"
      >
        <img className="w-auto!" src={medium}/>
      </div>
      <div className="flex justify-between pt-3xs">
        <div className="flex flex-col tablet:flex-row text-sm">
          <span className="font-bold mr-5xs">{Drupal.t('Sticker Size:')}</span>
          <span>{Drupal.t('(W) @width mm x (H) @height mm', { '@width': Math.ceil(panel_width), '@height': Math.ceil(panel_height) }, { context: 'QAU custom shape preview size label' })}</span>
        </div>
        <div>
          <Choose>
            <When condition={dispatchRef.current?.startQAU}>
              <ft-link class="text-sm desktop:text-base" href="#" variant="2" position=""
                       onClick={() => dispatchRef.current.startQAU()}>{Drupal.t('Edit Artwork & Size')}</ft-link>
            </When>
            <Otherwise>
              &nbsp;
            </Otherwise>
          </Choose>
        </div>
      </div>
    </div>
  );
};

export default CustomShapePreview;
